import React from "react";
import Aux from "../utils/AuxFunctions";
import "./Account.css"
import Fire from "../config/Fire";
import FacebookIcon from 'mdi-react/FacebookIcon';
import GoogleIcon from 'mdi-react/GoogleIcon';
import { withMyDataContext } from "../context/DataProvider";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Colors from "../utils/Colors";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import { Link } from "react-router-dom";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";
/* import { useHistory } from "react-router-dom";

const history = useHistory(); */

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            isLoading: false,
            error: "",
            facebookLoading: false,
            googleLoading: false,
        }
    }

    getUser = async() => {
        await Fire.shared.getUserData().then((didGetData) => {
            if(!didGetData){
                //this.props.myDataProvider.init();
               // this.setState({ isLoading: false, error: "You're not registered yet, please create an account" })
                this.props.history.push('/account/register/username')
            }else if(didGetData.username){
                this.props.myDataProvider.init();
                this.setState({ isLoading: false })
                this.props.history.push('/account/profile')
            }else{
                this.setState({ error: "An error has occurred, try again", isLoading: false })
            }
        });
    }

    onSubmit = async () => {
        if(this.state.facebookLoading || this.state.googleLoading || this.state.isLoading)
            return;

        this.setState({ isLoading: true, error: "" })
        try {
            if(!this.state.email){
                this.setState({error: "Add an Email",isLoading: false })
                //errorEmail = "Should not be empty"
                return;
            }
            if(!this.state.password){
                //errorPassword = "Should not be empty"
                this.setState({error: "Add a password",isLoading: false })
                return;
            }
            if (this.state.password && this.state.email && this.state.error === "") {
                await Fire.shared.firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password).then(async(cred) => {
                    console.log(cred)
                    this.setState({ isLoading: false })
                    if(cred){
                        await this.getUser();
                        if(this.props.myDataProvider.pendingCode){
                            await Fire.shared.addPromoCode()
                        }
                    }
                })
                
            }
            this.setState({isLoading: false})
        } catch (error) {

            switch (error.code) {
                case 'auth/wrong-password':
                    this.setState({ error: "Invalid Email or password" })
                    break;

                case 'auth/user-not-found':
                    this.setState({ error: "Invalid Email or password" })
                    break;
                case 'auth/invalid-email':
                    this.setState({ error: "Invalid Email or password" })
                    break;

                default:
                    
                    this.setState({ error: "An error has accurred" })
                    break;
            }
            Aux.handleError(error)
            this.setState({ isLoading: false })
        }
    }

    loginSocial= async(isFacebook) => {
        if(this.state.facebookLoading || this.state.googleLoading || this.state.isLoading)
            return;
        try{
            
            if(isFacebook){
                this.setState({facebookLoading:true});
                await Fire.shared.loginFacebook().then(async(result) => {
                    if(result === "error"){
                        this.setState({facebookLoading:false, error: "An error has occurred"});
                        return;
                    }
                })
            } else{
                this.setState({googleLoading:true});
                await Fire.shared.loginGoogle().then(async(result) => {
                    if(result === "error"){
                        this.setState({googleLoading:false, error: "An error has occurred"});
                        return;
                    }
                })
            }
            await this.getUser();

            this.setState({googleLoading:false, facebookLoading: false});
           
        }catch(error){
            this.setState({googleLoading:false, facebookLoading: false ,error: "An error has occurred"});
            Aux.handleError(error)
        }
    }

    goToRegister = () => {
        try{
            this.props.history.push("/account/register")
        }catch(error){
            Aux.handleError(error)
        }
    }

    goToRecover = () => {
        try{
            this.props.history.push("/account/recover")
        }catch(error){
            Aux.handleError(error)
        }
    }

    render() {
        const error = this.state.error;
        return (
            <div style={{width:"100%"}}>
                <section className="container">

                    {/* <img alt="logo" src={Aux.LogoImage} style={{ width: 50, objectFit: "contain" }}></img> */}
                    <div style={{marginBottom:20}}>
                        <h2 style={{marginBottom:20}}>Login</h2>
                        {/* <span>Welcome to Richless</span> */}
                        <span className="or-text">Connect with your email </span>
                    </div>

                    <div>
                        <ErrorMessage text={error}></ErrorMessage>
                            <TextInputMaterial
                                type="text" placeholder="Email" 
                                onChange={(e) => {
                                    this.setState({ email: e.target.value });
                                }}
                            />
                            <TextInputMaterial
                                type="password" placeholder="Password" style={{marginTop:15}}
                                onChange={(e) => {
                                    this.setState({ password: e.target.value });
                                }}
                            />
                        <div style={{display:"flex", justifyContent:"end", marginTop:5}}>
                            <span className="btn-hover" style={{color: "#aaa",}} onClick={this.goToRecover}>forgot password?</span>
                        </div>
                        <div style={{display:"flex", justifyContent:"center", marginTop:20}}>
                            <ButtonLoader 
                                text="Login" 
                                loading={this.state.isLoading} 
                                style={{backgroundColor: Colors.mainColor, height:45, width:"100%"}}
                                // icon={FacebookIcon}
                                onClick={this.onSubmit}
                            ></ButtonLoader>
                        </div>
                        
                        {/* <div style={{display:"flex", justifyContent:"center"}}>
                            <div style={{border:"1px solid #ccc", marginTop:30, marginBottom:10, width:"90%", borderRadius:20 }}/>
                        </div> */}
                        {/*     <div style={{borderWidth: 0.1, borderColor:"#ccc", borderStyle:"solid", margin:"auto", marginTop:30, width:"70%", borderRadius:50}}/> */}
                        <div style={{display:"flex", justifyContent:"center"}}>
                            <span style={{marginTop:20, color: Colors.middleText}}>Or connect with</span>
                        </div>
                        <div style={{display:"flex", marginTop:20, justifyContent:"space-between"}}>
                            {/* <a className="fb btn" style={{marginRight:10}} onClick={this.facebookLogin}>
                                <FacebookIcon></FacebookIcon>
                                <span className="btn-text">Facebook</span> 
                            </a> */}
                            <ButtonLoader 
                                text="Facebook" 
                                loading={this.state.facebookLoading} 
                                style={{backgroundColor: Colors.facebook, height:45, width: "48%", }}
                                icon={FacebookIcon}
                                onClick={() => this.loginSocial(true)}
                            />

                            <ButtonLoader 
                                text="Google" 
                                loading={this.state.googleLoading} 
                                style={{backgroundColor: Colors.google, height:45, width: "48%",}}
                                icon={GoogleIcon}
                                onClick={() => this.loginSocial(false)}
                            />

                        </div>
                        <div style={{borderWidth: 0.1, borderColor:"#ccc", borderStyle:"solid", margin:"auto", marginTop:30, width:"70%", borderRadius:50}}/>
                        <div style={{display:"flex", justifyContent:"center", marginTop:30}}>
                            <Link to={"/account/register"} style={{textDecoration:"none", textAlign:"center"}} className="text-hover"> 
                            <span style={{color:Colors.middleText}} className="text-hover">Don't have an account?</span>
                            <span style={{marginLeft:5}} className="footer-text red">Register</span>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default withMyDataContext(Login);